<template>
  <div class="paywall-overlay">
    <div class="paywall-card">
      <div class="paywall-lock">
        <i class="fa fa-lock" aria-hidden="true"></i>
      </div>
      <p class="paywall-title">
        この動画を視聴するには <br>
        動画の購入 <br>
        またはプレミアムのご登録が必要です
      </p>
      <div class="paywall-actions">
        <button
          class="btn btn-primary paywall-btn font-bold"
          @click="$emit('onBuy')"
        >
          <span>
            <i class="fa fa-shopping-cart" aria-hidden="true"></i>
            動画を購入
          </span>
        </button>
        <button class="btn btn-upgrade-premium paywall-btn" @click="$emit('onUpgrade')">
          <i class="fa fa-diamond" aria-hidden="true"></i>
          プレミアムに登録
        </button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loader: null
    }
  }
}
</script>
<style scoped>
.paywall-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(4px);
  z-index: 10;
  border-radius: inherit;
}
.paywall-card {
  background: #fff;
  border-radius: 8px;
  padding: 28px 32px;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0,0,0,0.4);
}
.paywall-lock {
  font-size: 32px;
  color: #cfb300;
  margin-bottom: 8px;
}
.paywall-title {
  font-weight: bold;
  font-size: 20px;
  color: #333;
}
.paywall-actions {
  display: flex;
  gap: 10px;
  i.fa-diamond {
    animation: rotateY 2s linear infinite;
  }
}
.paywall-btn {
  width: 50%;
}
.btn-upgrade-premium {
  background-color: rgba(207, 155, 0, 0.8);
  color: #000;
  font-size: 14px;
  padding: 5px;
  border-radius: 4px;
  z-index: 2;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/video/PaywallOverlay.vue